export const merchandiseFeatureKey = 'merchandise';
